<template>
    <span class="input-checkbox" :class="[{'input-checkbox--switch': isSwitch}]">
        <input
            :id="inputId"
            type="checkbox"
            :name="name"
            :checked="isChecked"
            :disabled="disabled"
            @change="handleChange"
        >
        <label :for="inputId"><slot /></label>
    </span>
</template>

<script>
/**
 * FormCheckbox — drop-in replacement for BV2's b-form-checkbox.
 *
 * Props:
 *   value          — the value emitted when checked (default: true)
 *   uncheckedValue — the value emitted when unchecked (default: false)
 *   disabled       — disables the input
 *   name           — input name attribute
 *   switch         — renders as a toggle switch (adds input-checkbox--switch class)
 *
 * v-model binds to `checked` prop (not `value`), matching BV2 behaviour.
 * Supports array models: if v-model is an array, value is added/removed from it.
 */

let uid = 0

export default {
    model: {
        prop: 'checked',
        event: 'input',
    },

    props: {
        checked:        { default: false },
        value:          { default: true },
        uncheckedValue: { default: false },
        disabled:       { type: Boolean, default: false },
        name:           { type: String, default: null },
        switch:         { type: Boolean, default: false },
    },

    data() {
        return {
            inputId: `form-checkbox-${++uid}`,
        }
    },

    computed: {
        isSwitch() {
            return this['switch']
        },

        isChecked() {
            if (Array.isArray(this.checked)) {
                return this.checked.includes(this.value)
            }
            return this.checked === this.value
        },
    },

    methods: {
        handleChange(e) {
            if (Array.isArray(this.checked)) {
                const newValue = [...this.checked]
                if (e.target.checked) {
                    newValue.push(this.value)
                } else {
                    const idx = newValue.indexOf(this.value)
                    if (idx > -1) newValue.splice(idx, 1)
                }
                this.$emit('input', newValue)
            } else {
                this.$emit('input', e.target.checked ? this.value : this.uncheckedValue)
            }
        },
    },
}
</script>
